type SkydioImportAccessInput = {
  canCreateInspectionUpload: boolean;
  inspectionUploadEnabled: boolean;
  skydioImportEnabled: boolean;
};

export const hasSkydioImportAccess = ({
  canCreateInspectionUpload,
  inspectionUploadEnabled,
  skydioImportEnabled,
}: SkydioImportAccessInput) =>
  inspectionUploadEnabled && skydioImportEnabled && canCreateInspectionUpload;
